import Cookies from "js-cookie";

import cnt from "../../services/definedConstant";
import { store } from "../storeOf";
import { logoutSession } from "../../services/authSession";

export const SignOutAction = () => {
  return async () => {
    await logoutSession();
    Cookies.remove("tfaToken", { path: "/" });
    store.dispatch({ type: cnt.SIGN_OUT });
    if (window?.DevtoolsSoftDetector) {
      window.DevtoolsSoftDetector.stop();
    }
  };
};
